import React, { useEffect } from 'react';
import { Row, Col, Space } from 'antd';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

// import { LanguageSelector } from '@life-line-lab/components-react';

import './footer.scss';
import { useRefreshLanguageSettingState } from 'Hooks/language-setting.hook';

const languageOptions = [
  {
    label: 'English',
    initial: 'EN',
    value: 'en',
  },
  {
    label: 'Bahasa Melayu',
    initial: 'BM',
    value: 'ms',
  }
];

export const Footer = () => {
  const dt = new Date();
  const currentYear = dt.getFullYear();
  const { t,i18n } = useTranslation();
  const history = useHistory();
  const [languageSetting, ] = useRefreshLanguageSettingState();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem("i18next", value);
    window.location.reload();
  }

  // if user does not have i18n language in localStorage, set the default language, if is different from the app.
  useEffect(() => {
    const currentLanguage = localStorage.getItem('i18next');
    if (currentLanguage) return;

    if (!languageSetting) return;

    const foundEcomLanguageObj = languageSetting.languageSetting.find(s => s.site === process.env.ACCOUNT_TYPE);
    if (foundEcomLanguageObj) {
      const foundI18NLanguage = languageOptions.find(m => m.initial === foundEcomLanguageObj.defaultLanguage);
      if (foundI18NLanguage && foundI18NLanguage.value !== i18n.language) {
        handleLanguageChange(foundI18NLanguage.value);
      }
    }
  }, [languageSetting])

  return (
    <React.Fragment>
      <div className="footer">
        <div className="footer-inner">
          <Space direction="vertical" size="large">
            <div className="footer--links">
              <Row gutter={16}>
                <Col xxl={14} xl={14} lg={14} md={24} sm={24} xs={24}>
                  <div className="footer--logo">
                    <img src="/assets/images/logo.png" />
                  </div>

                  <p dangerouslySetInnerHTML={{ __html: t('txt.aboutCompany')}} />

                  {/* <Space direction="horizontal" size="large">
                    <LanguageSelector
                      mode="long"
                      currentLanguage={i18n.language}
                      options={languageOptions}
                      onChange={handleLanguageChange}
                    />
                  </Space> */}

                  <p className="copyright" dangerouslySetInnerHTML={{ __html: t('txt.copyright', { year: currentYear === 2021 ? currentYear : `2021 - ${currentYear}` })}} />
                </Col>
                <Col xxl={5} xl={5} lg={5} md={12} sm={24} xs={24}>
                  <div className="company-info">
                    <h3 className="title">{t('title.company')}</h3>

                    <ul>
                      <li>
                        <a onClick={() => location.href='https://drezy.io/what-we-do'}>
                          {t('txt.about')}
                        </a>
                      </li>
                      <li>
                        <a onClick={() => location.href='https://drezy.io/#services'}>
                          {t('txt.services')}
                        </a>
                      </li>
                      <li>
                        <a onClick={() => location.href='https://drezy.io/#articles'}>
                          {t('txt.articles')}
                        </a>
                      </li>
                      <li>
                        <a onClick={() => location.href=`${process.env.BACKOFFICE_URL}`}>
                          {t('txt.businessCentre')}
                        </a>
                      </li>
                      <li>
                        <a onClick={() => location.href='https://drezy.io/contact-us?type=2'}>
                          {t('txt.appointment')}
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={5} xl={5} lg={5} md={12} sm={24} xs={24}>
                  <div className="help">
                    <h3 className="title">{t('title.help')}</h3>
                    <ul>
                      <li>
                        <a onClick={() => history.push('/support')}>
                          {t('txt.contactUs')}
                        </a>
                      </li>
                      <li>
                      <a onClick={() => history.push('/faq')}>
                          {t('txt.faq')}
                        </a>
                        </li>
                      <li>
                        <a onClick={() => history.push('/privacy')}>
                          {t('txt.privacyPolicy')}
                        </a>
                      </li>
                      <li>
                        <a onClick={() => history.push('/terms')}>
                          {t('txt.terms')}
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
          </Space>

          <div className="footer--socials">
              <Row gutter={16}>
                <Col className="left" xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Space size="small" direction="horizontal">
                    <a href="https://www.facebook.com/drezyhealth/" target="_blank">
                      <img src="/assets/images/media/facebook.svg" alt="Facebook" />
                    </a>

                    <a href="https://www.instagram.com/drezy.io/" target="_blank">
                      <img src="/assets/images/media/instagram.svg" alt="Instagram" />
                    </a>

                    <a href="https://twitter.com/drezy_health" target="_blank">
                      <img src="/assets/images/media/twitter.svg" alt="Twitter" />
                    </a>

                    <a href="https://www.linkedin.com/company/drezy/" target="_blank">
                      <img src="/assets/images/media/linkedin.svg" alt="LinkedIn" />
                    </a>

                    <a href="https://www.youtube.com/channel/UCNe_VIfdZ23v4VwZvmgpXew" target="_blank">
                      <img src="/assets/images/media/youtube.svg" alt="YouTube" />
                    </a>
                  </Space>
                </Col>

                <Col className="right" xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <a href="https://play.google.com/store/apps/details?id=com.drezy.phr" target="_blank">
                    <img src="/assets/images/media/google_play.svg" alt="Google Play" />
                  </a>

                  <a href="https://apps.apple.com/us/app/drezy/id1554742177" target="_blank">
                    <img src="/assets/images/media/app_store.svg" alt="App Store" />
                  </a>
                </Col>
              </Row>
            </div>
        </div>
      </div>

      <div className="footer--love">
        <div className="container" dangerouslySetInnerHTML={{ __html: t('txt.madeWithLove', { img: '<img src="/assets/images/footer/love.png" />' })}} />
      </div>
    </React.Fragment>
  )
}
